export default __webpack_public_path__ + "static/media/capacity-utilization.d8e92fb1.svg";